<p-messages    
    [key]="key"
    [styleClass]="menuOpen">
</p-messages>
